// Import model
import { CreateSurfaceRequest } from '../models/CreateSurfaceRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CreatePointRequest } from '../models/CreatePointRequest';

// Import dependency serializers (for complex types)
import { CreatePointRequestSerializer } from './CreatePointRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateSurfaceRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateSurfaceRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateSurfaceRequest instance
   */
  static deserialize(json: string): CreateSurfaceRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateSurfaceRequest instance
   */
  static fromObject(obj: any): CreateSurfaceRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateSurfaceRequest');
    }


    const instance: CreateSurfaceRequest = {
      area: obj['area'] as number | undefined,
      name: obj['name'] as string | undefined,
      perimeter: obj['perimeter'] as number | undefined,
      shape: obj['shape'] ? (obj['shape'] as any[]).map((item: any) =>
        CreatePointRequestSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateSurfaceRequest instances
   */
  static deserializeArray(json: string): CreateSurfaceRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateSurfaceRequest instance to a JSON string
   */
  static serialize(instance: CreateSurfaceRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateSurfaceRequest instance to a plain object
   */
  static toObject(instance: CreateSurfaceRequest): any {
    return {
      'area': instance.area,
      'name': instance.name,
      'perimeter': instance.perimeter,
      'shape': instance.shape?.map((item: any) =>
        CreatePointRequestSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of CreateSurfaceRequest instances to a JSON string
   */
  static serializeArray(instances: CreateSurfaceRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
